<template>
    <div class="o-proofCards u-w100 u-py20 u-overflowYAuto">
        <div class="o-proofCards__inner u-container">
            <ul v-if="modules && modules.length" class="m-accordion u-listUnstyled">
                <li 
                    v-for="(module, index) in modules" 
                    :key="index" 
                    class="m-accordion__item u-mb15 u-bgWhite u-br u-border"
                >
                    <a class="m-accordion__itemLink u-pt20 u-px20" :href="'/#/proofcards/'+module.id">
                        <div 
                            class="m-accordion__titleHolder u-pb20" 
                        >
                            <div class="m-accordion__title">
                                <h3 class="u-mb0">{{ module.title }}</h3>
                            </div>
                            <div class="m-accordion__right">
                                <div class="a-iconButton -tiny -secondary">
                                    <i class="bx bx-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '../services/api';

const modules = ref([]);

const fetchModules = async () => {
    try {
        const response = await api.get('/linked-modules');

        if (response.status === 200 && Object.keys(response.data).length !== 0) {

            modules.value = Object.values(response.data).map(module => ({
                id: module.id,
                title: module.title,
            }));

        }
        
    } catch (error) {
        console.error('Error fetching modules:', error);
    }
};

onMounted(() => {
    fetchModules();
});
</script>